import React from 'react';
import { Text } from '../../../../components/Typography';
import styles from './ResultCard.module.scss';

export interface SearchResult {
  id: string;
  similarity: number;
  documentName: string;
  companyName: string;
  content: string;
}

interface ResultCardProps {
  result: SearchResult;
}

const ResultCard: React.FC<ResultCardProps> = ({ result }) => {
  return (
    <div className={styles.resultCard}>
      <Text weight="bold">{result.companyName}</Text>
      <Text size="small" color="neutral-600">
        {result.documentName}
      </Text>
      <div className={styles.similarity}>
        <Text size="small" weight="medium" color="success-500">
          Similarity: {result.similarity.toFixed(4)}
        </Text>
      </div>
      <Text size="small" className={styles.contentSnippet}>
        "{result.content}..."
      </Text>
    </div>
  );
};

export default ResultCard;
